import { render, staticRenderFns } from "./GenericFileUploader.vue?vue&type=template&id=1fa77c5b"
import script from "./GenericFileUploader.vue?vue&type=script&lang=ts"
export * from "./GenericFileUploader.vue?vue&type=script&lang=ts"
import style0 from "./GenericFileUploader.vue?vue&type=style&index=0&id=1fa77c5b&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports